import React from 'react';
import { TikTokOutlined, WechatOutlined } from '@ant-design/icons';
import { detectScreen } from '../../utils/device';

const screen = detectScreen();

const OauthLinkMap = {
    wxopen_mini: `/wxopen/oauth?type=wxopen_mini&pageType=${screen}`,
    wxopen_service: `/wxopen/oauth?type=wxopen_service&pageType=${screen}`,
    alipay: '',
    douyin: '',
}

// <TikTokOutlined /> <WechatOutlined />
const ChannelCard = ({ icon = null, name='', title = 'title', description = 'description', list = [] }) => {

    const hasOauth = list.find((item) => item.name === name);

    return (
        <div className="flex items-start gap-3 p-4 border border-gray-200 rounded-lg w-full min-w-[260px] max-w-[390px] bg-white hover:shadow-md transition-shadow">
            {/* 图标 */}
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-gray-300 rounded-lg text-2xl">
                {icon}
            </div>
            
            {/* 内容区 */}
            <div className="flex-1 min-w-0">
                <div className="text-base font-bold text-gray-800 mb-1">{title}</div>
                <div className="text-sm text-gray-600 leading-relaxed">{description}</div>
            </div>
            
            {/* 操作按钮 */}
            <div className="flex-shrink-0">
                {
                    hasOauth ? (
                        <a href={`/channel/oauth/detail?type=${name}`} className="text-green-600 hover:text-green-700 whitespace-nowrap">
                            已授权 查看
                        </a>
                    ) : (
                        <a href={OauthLinkMap[name]} className="text-blue-600 hover:text-blue-700 whitespace-nowrap">
                            授权
                        </a>
                    )
                }
            </div>
        </div>
    )
}

export default () => {
    const [list, setList] = React.useState([]);
    const getChannleOauthList = async () => {
        const res = await fetch('/api/channel/oauth/list');
        return res.json();
    }
    React.useEffect(() => {
        getChannleOauthList().then((res) => {
            setList(res.data);
        })
    }, []);
    return (
        <div>
            <h2 className="admin-page-title">渠道授权管理</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <ChannelCard name='wxopen_mini' list={list} icon={<WechatOutlined />} title="微信小程序" description='将微信小程序与店铺绑定，深度开展品牌宣传和商品交易' />
                <ChannelCard name='wxopen_service' list={list} icon={<WechatOutlined />} title="微信服务号" description='绑定微信服务号，给客户提供深度消息服务' />
                {/* <ChannelCard name='alipay' list={list} icon={<AlipayOutlined />} title="支付宝小程序" description='连接支付宝亿级用户，打通线上线下渠道，共享商家生意增长新机会' />
                <ChannelCard name='douyin' list={list} icon={<TikTokOutlined />} title="抖音小程序" description='打通抖音本地生活，帮助商家快速获客，提高团购券核销，高效沉淀抖音粉丝。' /> */}
            </div>
        </div>
    )
}